var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative", "min-height": "200px" } },
    [
      _c("b-loading", {
        attrs: { active: _vm.items === null, "is-full-page": false }
      }),
      _c("div", { staticClass: "actions" }, [
        _c("div", { staticClass: "filtering" }, [
          _c(
            "div",
            { staticClass: "search" },
            [
              _c(
                "b-field",
                [
                  _c("b-input", {
                    attrs: {
                      placeholder: _vm.$t("documents.placeholder"),
                      icon: "search",
                      size: "is-small",
                      expanded: "",
                      disabled: !_vm.items || _vm.items.length === 0
                    },
                    model: {
                      value: _vm.query,
                      callback: function($$v) {
                        _vm.query = $$v
                      },
                      expression: "query"
                    }
                  }),
                  _vm.query
                    ? _c(
                        "button",
                        {
                          staticClass: "button is-small",
                          on: {
                            click: function($event) {
                              _vm.query = ""
                            }
                          }
                        },
                        [
                          _c("b-icon", {
                            attrs: { icon: "times-circle", size: "is-small" }
                          }),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("documents.btn-cancel")))
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c("div", { staticClass: "unread" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.showUnread,
                  expression: "showUnread"
                }
              ],
              attrs: { type: "checkbox", id: "unread-checkbox" },
              domProps: {
                checked: Array.isArray(_vm.showUnread)
                  ? _vm._i(_vm.showUnread, null) > -1
                  : _vm.showUnread
              },
              on: {
                change: function($event) {
                  var $$a = _vm.showUnread,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.showUnread = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.showUnread = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.showUnread = $$c
                  }
                }
              }
            }),
            _c("span", { attrs: { id: "unread-label" } }, [
              _vm._v(_vm._s(_vm.$t("documents.unread-label")))
            ])
          ])
        ]),
        _c("div", { staticClass: "expand-all" }, [
          _c(
            "button",
            {
              staticClass: "button is-small",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.toggleExpanded($event)
                }
              }
            },
            [
              _c("b-icon", { attrs: { icon: "sitemap", size: "is-small" } }),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.expanded
                      ? _vm.$t("documents.close")
                      : _vm.$t("documents.open")
                  )
                )
              ])
            ],
            1
          )
        ])
      ]),
      _vm.query
        ? _c(
            "div",
            [
              _c("h1", { staticClass: "is-size-4" }, [
                _vm._v(_vm._s(_vm.$t("documents.query")))
              ]),
              _vm.filteredItems.length === 0
                ? _c("b-message", [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("documents.queryempty1")) +
                        "\n    "
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      !_vm.query && _vm.showUnread
        ? _c(
            "div",
            [
              _vm.filteredItems.length === 0
                ? _c("b-message", [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("documents.queryempty2")) +
                        "\n    "
                    )
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.items && _vm.items.length === 0
        ? _c("b-message", [
            _vm._v("\n    " + _vm._s(_vm.$t("documents.queryempty3")) + "\n  ")
          ])
        : _vm._e(),
      _vm.filteredItems.length > 0
        ? _c("PortefeuilleArbo", {
            ref: "arbo",
            attrs: {
              items: _vm.filteredItems,
              query: _vm.query,
              showUnreadOnly: _vm.showUnread
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }